const DataGrid = mode => {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }) => ({
          border: 0,
          color: 'var(--mui-palette-text-primary)',
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none'
          }
        }),
        toolbarContainer: ({ theme }) => ({
          paddingRight: `${theme.spacing(6)} !important`,
          paddingLeft: `${theme.spacing(3.25)} !important`
        }),
        columnHeader: ({ theme }) => ({
          backgroundColor: 'var(--mui-palette-customColors-tableHeaderBg)',
          color: 'var(--mui-palette-text-primary)',
          '&:not(.MuiDataGrid-columnHeaderCheckbox)': {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            '&:first-of-type': {
              paddingLeft: theme.spacing(6)
            }
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(6)
          }
        }),
        columnHeaderCheckbox: {
          maxWidth: '58px !important',
          minWidth: '58px !important'
        },
        columnHeaderTitleContainer: {
          padding: 0
        },
        columnHeaderTitle: ({ theme }) => ({
          fontWeight: 500,
          letterSpacing: '1px',
          textTransform: 'uppercase',
          fontSize: theme.typography.body2.fontSize,
          color: 'var(--mui-palette-text-primary)'
        }),
        columnSeparator: ({ theme }) => ({
          color: 'var(--mui-palette-divider)'
        }),
        row: ({ theme }) => ({
          '&:hover': {
            backgroundColor: 'var(--mui-palette-action-hover)'
          },
          '&.Mui-selected': {
            backgroundColor: 'var(--mui-palette-action-selected)',
            '&:hover': {
              backgroundColor: 'var(--mui-palette-action-selected)'
            }
          },
          '&:last-child': {
            '& .MuiDataGrid-cell': {
              borderBottom: 0
            }
          }
        }),
        cell: ({ theme }) => ({
          borderColor: 'var(--mui-palette-divider)',
          color: 'var(--mui-palette-text-primary)',
          '&:not(.MuiDataGrid-cellCheckbox)': {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            '&:first-of-type': {
              paddingLeft: theme.spacing(6)
            }
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(6)
          },
          '&:focus, &:focus-within': {
            outline: 'none'
          }
        }),
        cellCheckbox: {
          maxWidth: '58px !important',
          minWidth: '58px !important'
        },
        editInputCell: ({ theme }) => ({
          padding: 0,
          color: 'var(--mui-palette-text-primary)',
          backgroundColor: 'var(--mui-palette-background-paper)',
          '& .MuiInputBase-input': {
            padding: 0
          }
        }),
        footerContainer: ({ theme }) => ({
          borderTop: '1px solid var(--mui-palette-divider)',
          backgroundColor: 'var(--mui-palette-customColors-tableHeaderBg)',
          '& .MuiTablePagination-toolbar': {
            paddingLeft: `${theme.spacing(4)} !important`,
            paddingRight: `${theme.spacing(4)} !important`
          },
          '& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel': {
            color: 'var(--mui-palette-text-secondary)'
          },
          '& .MuiTablePagination-select': {
            color: 'var(--mui-palette-text-primary)'
          },
          '& .MuiTablePagination-actions .MuiIconButton-root': {
            color: 'var(--mui-palette-text-primary)',
            '&.Mui-disabled': {
              color: 'var(--mui-palette-text-disabled)'
            }
          }
        }),
        selectedRowCount: ({ theme }) => ({
          margin: 0,
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(4),
          color: 'var(--mui-palette-text-secondary)'
        }),
        virtualScroller: ({ theme }) => ({
          backgroundColor: 'var(--mui-palette-background-paper)'
        }),
        overlay: ({ theme }) => ({
          backgroundColor: 'var(--mui-palette-background-paper)'
        })
      }
    }
  }
}

export default DataGrid
